module.exports = __webpack_public_path__ + "static/img/news2_2.a6c12d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news2_2.jpg
// module id = Sqbz
// module chunks = 0